<template>
    <access-denied v-if="accessDenied" title="formas-pagamento" />
    <div id="main" v-else>
        <div class="page">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('formas-pagamento') }}
                        </h1>
                        <!--  -->
                        <nav class="breadcrumb" aria-label="breadcrumbs" v-if="cameFrom == 'route'">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('vendas') }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t('cadastros') }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t('formas-pagamento') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="cameFrom != 'route'"
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$emit('voltar', true)"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="!integracao && permissao.create && cameFrom == 'route'"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: 'des-forma-pagamento-new',
                                })
                            "
                        >
                            {{ $t('adicionar') }}
                        </button>
                    </div>
                </div>

                <div class="columns mb-0">
                    <div class="column is-9">
                        <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-campo-busca-forma-pagamento-descricao" />
                    </div>

                    <div class="column is-3">
                        <vss-select
                            title="situacao"
                            ref="situacaoSelect"
                            :options="situacoes"
                            v-model="situacao"
                            label="label"
                            :height="40"
                            mlLabels
                            @input="onSituacaoChanged"
                            clearable
                        />
                    </div>
                </div>

                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="formasPagamento"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                            'label-km': f.key == 'label',
                        }"
                        :sortable="f.sortable"
                        :visible="f.visible"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'descricao'">
                            <router-link
                                v-if="cameFrom == 'route'"
                                :to="{
                                    name: 'des-forma-pagamento-edit',
                                    params: { id: props.row.id },
                                }"
                            >
                                {{ props.row[f.key] }}
                            </router-link>
                            <a v-else @click="$emit('edit', props.row.id)">
                                {{ props.row[f.key] }}
                            </a>
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <span>
                                <b-button
                                    v-if="permissao.delete && !integracao"
                                    class="action-button"
                                    :type="
                                        props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                    "
                                    :icon-right="
                                        props.row['situacao'] == 1 ? 'delete' : 'check'
                                    "
                                    @click="promptChangeSituacao(props.row)"
                                    v-tippy 
                                    :title="$t(
                                        props.row['situacao'] == 1 ? 'desativar' : 'reativar'
                                    )"
                                />
                            </span>
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row[f.key] == 1"
                                type="is-success"
                                size="is-medium"
                            >
                                {{ $t('ativo') }}
                            </b-tag>
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                            >
                                {{ $t('inativo') }}
                            </b-tag>
                        </div>
                        <div v-else-if="f.key == 'debita_acerto'">
                            {{ props.row[f.key] == 0 ? $t('nao') : $t('sim') }}
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import DespesaFormapagtoService from '@/services/despesas/DespesaFormapagtoService';

export default {
    name: 'DesFormaPagamentoList',

    components: {
        ContainerLoader,
    },
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        idFrom: {
            type: Number,
            default: 0,
        },
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('DES_FORMAPAGTO'),
            formasPagamento: [],
            situacoes: [
                { id: 0, label: 'inativos' },
                { id: 1, label: 'ativos' },
                { id: 2, label: 'todos' },
            ],
            situacao: { id: 2, label: 'todos' },
            service: new DespesaFormapagtoService(this.$http, this.$router),
            fields: [
                { key: 'codigo', sortable: true, sortFn: null, visible: true },
                { key: 'descricao', width: null, sortable: true, sortFn: null, visible: true },
                { key: 'debita_acerto', width: null, sortable: true, sortFn: null, visible: true },
                { key: 'situacao', width: 80, sortable: false, sortFn: null, visible: true },
                { key: 'excluir', width: 20, sortable: false, sortFn: null, visible: true },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: true,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
            permissao: {},
            accessDenied: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess('despesas', 'cadastros', 'des-forma-pagamento');
        if (this.cameFrom != 'route') {
            let temp = this.fields.find((f) => f.key == 'excluir');
            temp.visible = false;
        }
        if (!this.permissao.read) {
            this.accessDenied = true;
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    watch: {
        reloadData(val) {
            if (val) this.carregarDados(this.pagination.currentPage);
        },
    },
    methods: {
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[2];
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.formasPagamento = value;
                    this.isEmpty = this.formasPagamento.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os prazos.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    id: m.id,
                    codigo: m.iddes_formapagtoerp,
                    descricao: m.descricao,
                    debita_acerto: m.debita_acerto,
                    situacao: m.situacao,
                    excluir: 'excluir',
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-erro-ao-desativar-forma-pagamento'
                    : 'msg-erro-ao-reativar-forma-pagamento';

            let tempFormaPagamento = {
                iddes_formapagto: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempFormaPagamento)
                .then((r) => {
                    if (r.status == 200) {
                        if (r.content.situacao == 1) {
                            this.$root.showMessage(
                                'success',
                                'msg-sucesso-ao-reativar-forma-pagamento'
                            );
                        } else if (r.content.situacao == 0) {
                            this.$root.showMessage(
                                'success',
                                'msg-sucesso-ao-desativar-forma-pagamento'
                            );
                        }
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    background-color: $bg-color;
    border-radius: 5px;
    padding: 5px 20px;
    height: 100%;

    .page {
        padding-left: 0;
        .table-tag {
            width: 5rem !important;
        }
    }
}
</style>
